// extracted by mini-css-extract-plugin
export default {"pageHeader":"ErrorSection_pageHeader__ygoTJ","infoMessage":"ErrorSection_infoMessage__e-u3z","pageContainer":"ErrorSection_pageContainer__hUfEy"};